<template>
  <div class="relative flex flex-col min-w-0 break-words w-full h-full mb-4 shadow-lg rounded-lg bg-white">
    <!-- <router-link to="/general/dashboard"> -->
    <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
      <div class="flex flex-wrap items-center">
        <div class="relative w-full max-w-full flex-grow flex-1">
          <h6 class="uppercase text-blueGray-400 mb-1 text-xs font-semibold">
            Student class schedule
          </h6>
          <div class="flex flex-wrap items-center">
            <h2 class="text-blueGray text-xl font-semibold">
              Where are Students Studying?
            </h2>
            <div class="relative w-full max-w-full flex-grow flex-1 text-right">
              <input id="student_id" type="text" @keyup.enter="searchStudent"
                class="text-sm flex-auto rounded-md border bg-white mr-2 px-3.5 py-2 text-black shadow ring-1 ring-inset ring-white/10 
                focus:ring-2 focus:ring-inset focus:ring-gray-500 sm:text-sm sm:leading-6"
                placeholder="Enter your student id">
              <!-- <button @click="toggleAccordion(26)" class="accordion-header cursor-pointer text-md
               text-white active:bg-blueGray-100 px-3 py-1 rounded outline-none focus:outline-none mr-1 
               mb-1 ease-linear transition-all duration-150 bg-blueGray-700" type="button">
                Search</button> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="p-4 flex-auto text-center">
      <div class="flex flex-wrap justify-center">
          <img
            class="h-350-px justify-center"
            :src="searching"
            v-if="calendar_student_arr.length === 0"
          />
          
        <table class="items-center w-full border-collapse bg-blueGray-100 rounded-lg shadow-md" v-if="showAccordion[1]"
        >
          <tbody>
            <tr>
              <td class="border-t-0 p-2 w-20 font-semibold px-6 align-middle border-l-0 border-r-0 whitespace-nowrap text-left bg-blueGray-600 text-white"
              style="border-radius: 0.8rem 0rem 0rem 0rem;">
                Course Name : 
              </td>
              <td class="border-t-0 p-2 px-6 align-middle border-l-0 border-r-0 whitespace-nowrap text-left">
                {{calendar_student_arr.course_name}}
              </td>
            </tr>
            <tr>
              <td class="border-t-0 p-2 w-20 font-semibold px-6 align-middle border-l-0 border-r-0 whitespace-nowrap text-left bg-blueGray-600 text-white">
                Class Year : 
              </td>
              <td class="border-t-0 p-2 px-6 align-middle border-l-0 border-r-0 whitespace-nowrap text-left">
                {{calendar_student_arr.class_year}}
              </td>
            </tr>
            <tr>
              <td class="border-t-0 p-2 w-20 font-semibold px-6 align-middle border-l-0 border-r-0 whitespace-nowrap text-left bg-blueGray-600 text-white">
                Time : 
              </td>
              <td class="border-t-0 p-2 px-6 align-middle border-l-0 border-r-0 whitespace-nowrap text-left">
                {{calendar_student_arr.times}}
              </td>
            </tr>
            <tr>
              <td class="border-t-0 p-2 px-6 align-middle font-semibold border-l-0 border-r-0 whitespace-nowrap text-left bg-blueGray-600 text-white">
                Subject/Subject Group : 
              </td>
              <td class="border-t-0 p-2 px-6 align-middle border-l-0 border-r-0 whitespace-nowrap text-left ">
                {{calendar_student_arr.subject_name}}
              </td>
            </tr>
            <tr>
              <td class="border-t-0 p-2 px-6 align-middle font-semibold border-l-0 border-r-0 whitespace-nowrap text-left bg-blueGray-600 text-white">
                Topic : 
              </td>
              <td class="border-t-0 p-2 px-6 align-middle border-l-0 border-r-0 whitespace-nowrap text-left">
                {{calendar_student_arr.topic}}
              </td>
            </tr>  
            <tr>
              <td class="border-t-0 p-2 px-6 align-middle font-semibold border-l-0 border-r-0 whitespace-nowrap text-left bg-blueGray-600 text-white">
                Lecturer : 
              </td>
              <td class="border-t-0 p-2 px-6 align-middle border-l-0 border-r-0 whitespace-nowrap text-left ">
                {{calendar_student_arr.lecturer}}
              </td>
            </tr>  
            <tr>
              <td class="border-t-0 p-2 px-6 align-middle font-semibold border-l-0 border-r-0 whitespace-nowrap text-left bg-blueGray-600 text-white"
              style="border-radius: 0rem 0rem 0rem 0.8rem;">
                Room : 
              </td>
              <td class="border-t-0 p-2 px-6 align-middle border-l-0 border-r-0 whitespace-nowrap text-left ">
                {{calendar_student_arr.room}}
              </td>
            </tr>          
          </tbody>
        </table>

      </div>

    </div>
  </div>
</template>

<script>
import api from './../../services/student_services';
import searching from "@/assets/img/searching.gif";

export default {
  data() {
    return {
      searching,
      calendar_student_arr: [],
      data_id: { 
        "student_id": '' ,
      },
      showAccordion: {
        1: false
      },
    }
  },
  methods: {
    searchStudent() {
      this.showAccordion[1] = true;

      this.data_id = {
        "student_id": document.getElementById('student_id').value ,
      }

      api.calendar_student(this.data_id).then(async (result) => {
        this.calendar_student_arr = result.data;
        //console.log(result.data)
      });
    },
  },
};
</script>